export const boardCertifiedInfoIconText = {
  'abyss-text-root': {
    padding: '5px 6px 0px 0px',
    fontSize: '$smallText !important',
    fontWeight: '600 !important',
    lineHeight: '14px !important',
    height: '18px',
    width: 'fit-content',
    color: '$core.color.brand.60 !important',
  },
};
